<template>
  <vue-apex-charts
    class="donutProgresso"
    type="donut"
    :series="series"
    :options="chartOptions"
    :height="height"
    :width="'100%'"
  />
</template>

<style lang="scss">
.donutProgresso .apexcharts-tooltip {
  color: rgb(0, 0, 0);
  font-family: inherit;
  font-weight: 400;
}
</style>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DonutChartProgresso',
  components: {
    VueApexCharts,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dados: {
      type: Object,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    height: {
      type: String,
      default: '182',
    },
  },
  data() {
    return {
      series: this.dados.valoresEquipe,
      chartOptions: {
        chart: {
          id: this.id,
          type: 'donut',
          height: this.height,
          width: '100%',
        },
        stroke: {
          colors: ['#000000'],
          width: 0.3,
        },
        colors: this.dados.cores,
        dataLabels: {
          enabled: false,
          formatter: val => `${val}%`,
          style: {
            fontSize: '12px',
            fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
            fontWeight: 400,
          },
        },
        legend: {
          show: false,
        },
        labels: this.dados.equipesNomes,
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '12px',
                  fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                  fontWeight: 500,
                  color: '#5c5a5a',
                  formatter: () => this.dados.quantidadeDocumentosEquipes.reduce((partialSum, a) => partialSum + a, 0).toLocaleString('pt-BR'),
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 700,
                  fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                  formatter: v => `${v}%`,
                },
                total: {
                  show: true,
                  fontSize: '12px',
                  fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                  fontWeight: 500,
                  color: '#5c5a5a',
                  formatter: () => `${this.total}%`,
                },
              },
            },
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val, v) => `${this.dados.quantidadeDocumentosEquipes[v.seriesIndex]}`,
            title: {
              formatter: val => `${val}:`,
            },
          },
        },
      },
    }
  },
}
</script>
